<template>
  <div :class="classModifiers">
    <div class="content-loader content-loader--dashboard-notifications" v-if="!isComponentReady">
      <notification-loader></notification-loader>
      <notification-loader></notification-loader>
      <notification-loader></notification-loader>
    </div>
    <template v-else>
      <div class="notifications-list__content">
        <notification-item-dashboard
          :theme="theme"
          :showTimeElapsed="true"
          class="notifications-list__item"
          :key="notification.notificationId"
          :index="index"
          :data="notification"
          v-for="(notification, index) in items"
        >
        </notification-item-dashboard>
        <div v-if="isScrollMore" class="notifications-list__scroll-down">
          Scroll down for more notifications
        </div>
        <infinite-loading @infinite="goInfinite" v-if="showInfiniteLoading" :distance="150">
          <template v-slot:spinner>
            <span>
              <div class="notifications-list__spinner"></div>
            </span>
          </template>
          <template v-slot:complete>
            <span></span>
          </template>
        </infinite-loading>
      </div>
      <div v-if="notificationsCount === 0" class="notifications-list__footer-no-notifications">
        There are no notifications to display
      </div>
      <div
        v-if="limit !== null && notificationsCount > 0"
        class="notifications-list__link"
        @click="onSeeAllClick"
      >
        See All Notifications
      </div>
    </template>
  </div>
</template>

<script src="./notifications-list.js"></script>
<style src="./notifications-list.scss" lang="scss"></style>
